// Companion to BetaBanner for the certificate surfaces. The staging seed
// rosters portray video-game characters (OSRS NPCs, LoL champions, CS
// agents — see server/src/services/seed_service.rs), and a certificate is
// the one artifact a beta tester will screenshot and share. This line keeps
// the IP posture on the artifact itself: unofficial fan content, publishers
// credited, no affiliation implied.
//
// Same env contract as BetaBanner: driven by the baked REACT_APP_ENV,
// renders NOTHING in production (real creators need no such notice), and
// fail-visible when the env is unset — an environment we can't identify is
// treated as a demo, never as live.

const NOTICE_TEXT =
  "Demo content: seeded creators portray video-game characters — © their publishers (Jagex, Riot Games, Valve). Unofficial fan content, not affiliated with or endorsed by the publishers.";

export function DemoContentNotice({
  env = import.meta.env.REACT_APP_ENV as string | undefined,
}: {
  env?: string;
}) {
  if (env === "production") return null;
  return (
    <p
      data-testid="demo-content-notice"
      className="text-center text-[11px] leading-snug opacity-50"
    >
      {NOTICE_TEXT}
    </p>
  );
}
